<script>
import axios from 'axios';
export default {
    methods: {
        validateStep1() {
            const data = this.SelectedData;
            const errors = [];
            if(!data.firstName) {
                errors.push('First Name');
            }
            if(!data.lastName) {
                errors.push('Last Name');
            }
            if(!this.validEmail(data.email)) {
                errors.push('Email');
            } else if(data.email != data.confirmEmail) {
                errors.push('Email Doesn\'t Match');
            }
            if(!data.describeOption) {
                errors.push('Which option best describes you?');
            }
            if(!data.fileUploaded) {
                errors.push('Upload Your Document');
            }
            if(!data.englishType) {
                errors.push('English Type');
            }
            if(!data.selectedWritingStyle) {
                errors.push('Writing Style');
            }
            if(!data.recaptchaResponse && window.location.href !== 'http://192.168.0.17:8080/' && !this.recaptchaDisable) {
                errors.push('Please confirm "I\'m not a robot" field.');
            }

            if(errors.length) {
                this.errors = errors;
                window.scrollTo(0, 0);
                return false;
            } else {
                this.errors = false;
            }
            return true;
        },
        validEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validateEmailCode() {
            this.errors = false;
            const formData = new FormData();
            formData.append('code', this.SelectedData.code);
            formData.append('email', this.SelectedData.email);
            formData.append('firstName', this.SelectedData.firstName);
            formData.append('lastName', this.SelectedData.lastName);
            formData.append('organization', this.SelectedData.organization);
            formData.append('describeOption', this.SelectedData.describeOption);
            formData.append('post_file', this.SelectedData.fileUploaded.url);
            formData.append('english_type', this.SelectedData.englishType);
            formData.append('message', this.SelectedData.message);
            formData.append('wstyleval', this.SelectedData.selectedWritingStyle.name);
            return axios
                .post(this.siteUrl + 'include/API/validateEmailCode.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    console.log(response.data);
                    if(response.data.status == 'already requested') {
                        const errors = [];
                        errors.push('Free samples are only allowed for new customers. Only one free sample is allowed per customer and/or household.');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                        return false;
                    } else if(response.data.status == 'banned') {
                        const errors = [];
                        errors.push('(ERROR CODE: 001) Unfortunately, your transaction cannot continue. Please contact ProofreadingPal customer service.');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                        return false;
                    } else if(response.data.status == 'success') {
                        this.SelectedData.transactionId = response.data.transactionId;
                        this.SelectedData.finalTurnaround = response.data.finalTurnaround;
                        return true;
                    } else {
                        const errors = [];
                        errors.push('The Email Validation Code is not matching or has expired. Please try again.');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                        return false;
                    }
                    
                });
        },
        sendEmailValidation(resend) {
            this.errors = false;
            const formData = new FormData();
            formData.append('email', this.SelectedData.email);
            formData.append('firstName', this.SelectedData.firstName);
            formData.append('lastName', this.SelectedData.lastName);
            if(resend) {
                formData.append('recaptcha', 'resend');
            } else {
                formData.append('recaptcha', this.SelectedData.recaptchaResponse);
            }
            
            axios
                .post(this.siteUrl + 'include/API/sendEmailValidation.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    this.SelectedData.sendingMail = false;
                    if(response.data == 'recaptcha error') {
                        const errors = [];
                        errors.push('Please confirm "I\'m not a robot" field.');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                    } else if(response.data == 'code is sent') {
                        this.SelectedData.emailSent = true;
                        if(resend) {
                            this.SelectedData.resent = true;
                        }
                        this.mailValidationSent = true;
                    } else if(response.data == 'lot of tries') {
                        const errors = [];
                        errors.push('Our system recorded to many attempts. Please contact ProofreadingPal customer support.');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                    } else if(response.data == 'code not valid') {
                        const errors = [];
                        errors.push('Email code is not valid.');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                    }
                });
        },
    }
}
</script>